module.exports = __webpack_public_path__ + "4920cbfcd54b6c13866f1cfefbfb528a.svg";